import { DashboardSavedsearchReportsState } from './dashboardSavedsearchReportsData.state';
import { RootReducerState } from './../ngrx.imports';
import { createSelector } from '@ngrx/store';

export const getDashboardSavedsearchReportsState = (state: RootReducerState) => state.dashboardSavedsearchReports;


//Selectors
export const getDashboardSavedsearchReportsAllData = (state: DashboardSavedsearchReportsState) => state.dashboardSavedsearchReports;
export const selectorDashboardSavedsearchReportsAllData = createSelector(getDashboardSavedsearchReportsState, getDashboardSavedsearchReportsAllData);
